import { render, staticRenderFns } from "./DetalhesOcorrenciaModalManage.vue?vue&type=template&id=5a6a6e8e&scoped=true"
import script from "./DetalhesOcorrenciaModalManage.vue?vue&type=script&lang=js"
export * from "./DetalhesOcorrenciaModalManage.vue?vue&type=script&lang=js"
import style0 from "./DetalhesOcorrenciaModalManage.vue?vue&type=style&index=0&id=5a6a6e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a6e8e",
  null
  
)

export default component.exports